import React, { useEffect, useState } from "react";
import {Button, Paper, Box, Autocomplete, TextField, Typography, IconButton, MenuItem} from '@mui/material';
import Geometry from "./Geometry";
import { useNavigate, useParams } from "react-router-dom";
import router from "../../routePaths/routePaths";
import { Close, Done, Edit } from "@mui/icons-material";

export default function UpdateRateForm(props) {
    let navigate = useNavigate();
    const {domain} = useParams();
    const [time, setTime] = useState([]);

    const handleChange = (e) =>{
        setTime({...time, [e.target.name]: e.target.value})
    }
    useEffect(()=>{},[props.rates])

    const timeOptions = Array.from({ length: 25 }, (_, i) => {
        const value = i === 24 ? "24:00" : `${String(i).padStart(2, "0")}:00`;
        return value;
    });

    return (
        <Paper elevation={0} sx={{ width: '100%', p: 3}}>
            <Typography variant="body1" className="font-bold">Update Rate</Typography>
            <form onSubmit={props.handleSubmit}>
                <div className="row">
                    <div className='col-lg-6'>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={props.installations}
                            getOptionLabel={(option) => `${option.ins_description} - ${option.ins_id}`}
                            name="selectedIns"
                            value={props.selectedIns}
                            onChange={(event, newValue)=>props.onInsSelect(newValue)}
                            renderInput={(params) =>
                            <TextField 
                                {...params} id="standard-basic" 
                                label="City" variant="standard" 
                                className="width-90 mt-2" 
                                required
                            />}
                    />
                    </div>
                    <div className='col-lg-6'>
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={props.groups}
                            getOptionLabel={(option) => `${option.GRP_DESCRIPTION} - ${option.grp_id}`}
                            name="selectedIns"
                            value={props.selectedGrp}
                            onChange={(event, newValue)=>props.onGrpSelect(newValue)}
                            renderInput={(params) =>
                            <TextField 
                                {...params} id="standard-basic" 
                                label="Zone" variant="standard" 
                                className="width-90 mt-2" 
                                required
                            />}
                    />
                    </div>
                    <div className='col-lg-12 mt-2'>
                        {props.polygon.length > 0 && <Geometry
                            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDcPvfjCIqeUpGe8_IaI_-5rIZX9qtCUnI&libraries=drawing,places"
                            loadingElement={<div style={{ height: `100%` }} />}
                            containerElement={<div style={{ height: `55vh` }} />}
                            mapElement={<div style={{ height: `100%` }} />}
                            polygon={props.polygon}
                        />}
                    </div>
                </div>
                <div className="row">
                    {props.tarIds.map((tarId, tarIndex)=>{
                        return(
                            <div className='col-lg-6 mt-2'>
                                <b>Tariff Assigned {tarIndex+1}: </b>
                                <span>
                                    {tarId}
                                </span>
                            </div>
                        )
                    })}
                </div>
                {props.rates.length > 0 && 
                    props.rates.map((x,index) => {
                        return(
                            <div className="row">
                                <div className='col-lg-6'>
                                    <TextField
                                        id="standard-basic"
                                        label={x.RAT_DESCRIPTION} variant="outlined" 
                                        name={x.RAS_RAT_ID+"_"+index+"_desc"} value={props.inputField[x.RAS_RAT_ID+"_"+index+"_desc"]}
                                        className="width-90 mt-4" onChange={props.handleChange}
                                        InputLabelProps={{ shrink: true }} required size='small'/>
                                </div>
                                <div className='col-lg-6'>
                                    <div className='show-time'>  
                                    {/* <b>Time: </b> */}
                                    {x.dah_desc.map((element,key) => {
                                            return(
                                                <div className="mt-2 gap-2 d-flex align-items-center" key={key}>
                                                    {props.isEditable.rate === index && props.isEditable.dah === key && <>
                                                        <TextField
                                                            select
                                                            label="Start Time"
                                                            name="start_time"
                                                            value={time.start_time}
                                                            onChange={handleChange}
                                                            InputLabelProps={{ shrink: true }}
                                                            size='small'
                                                        >
                                                            {timeOptions.map((option) => (
                                                                <MenuItem key={option} value={option}>
                                                                    {option}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>

                                                        <TextField
                                                            select
                                                            label="End Time"
                                                            name="end_time"
                                                            value={time.end_time}
                                                            onChange={handleChange}
                                                            InputLabelProps={{ shrink: true }}
                                                            size='small'
                                                        >
                                                            {timeOptions.map((option) => (
                                                                <MenuItem key={option} value={option}>
                                                                    {option}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>
                                                        <IconButton onClick={()=>{
                                                                props.setIsEditable({});
                                                            }}>
                                                            <Close />
                                                        </IconButton>
                                                        <IconButton onClick={()=>
                                                            props.onUpdateTime({
                                                                rate: x,
                                                                dah: element,
                                                                start_time: time.start_time,
                                                                end_time: time.end_time
                                                            })}>
                                                            <Done />
                                                        </IconButton>
                                                    </>}
                                                    {(props.isEditable.rate !== index || props.isEditable.dah !== key) && <>
                                                        <span>
                                                            {element.DAH_DESCRIPTION} ({element.DAH_INI_HOUR} - {element.DAH_END_HOUR})
                                                        </span>
                                                        <IconButton onClick={()=>{
                                                                props.setIsEditable({rate: index, dah: key});
                                                                setTime({start_time: element.DAH_INI_HOUR, end_time: element.DAH_END_HOUR})
                                                            }}>
                                                            <Edit />
                                                        </IconButton>
                                                    </>}
                                                </div>
                                            )
                                        })
                                    }
                                    </div>
                                </div>
                                <div className="row">
                                {/* <Typography variant="subtitle" className="font-bold mt-3">{x.RAT_DESCRIPTION}</Typography> */}
                                        {x.RATE_STEPS.map((y,z)=>{
                                            return(
                                                <>
                                                    {z == 0 && <div className='col-lg-6'>
                                                        <TextField
                                                            id="standard-basic" type={'number'}
                                                            label={(x.RATE_STEPS.length > 1)?"Minimum in cents":"Rate in Cents"} variant="standard" 
                                                            name={x.RAS_RAT_ID+"_"+z+"_rate"} value={props.inputField[x.RAS_RAT_ID+"_"+z+"_rate"]}
                                                            className="width-90 mt-2" onChange={props.handleChange}
                                                            InputLabelProps={{ shrink: true }} required/>
                                                    </div>}
                                                    {z == x.RATE_STEPS.length-1 && x.RATE_STEPS.length > 1 && <div className='col-lg-6'>
                                                        <TextField
                                                            id="standard-basic" type={'number'}
                                                            label={"Maximum in cents"} variant="standard" 
                                                            name={x.RAS_RAT_ID+"_"+z+"_rate"} value={props.inputField[x.RAS_RAT_ID+"_"+z+"_rate"]}
                                                            className="width-90 mt-2" onChange={props.handleChange}
                                                            InputLabelProps={{ shrink: true }} required/>
                                                    </div>}
                                                </>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        )
                    })
                }
                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                    <Box sx={{ flex: '1 1 auto' }} />
                    <Button className="btn btn-blue px-3 mx-2 fit-content" onClick={()=>navigate(router.new_rate+'/24_hr_rate'+'/'+domain)}>
                        Add 24hr rate
                    </Button>
                    <Button className="btn btn-blue px-3 mx-2 fit-content" onClick={()=>navigate(router.new_rate+'/day_night_weekend_rate'+'/'+domain)}>
                        Add Day, Night and Weekend rate
                    </Button>
                    <Button className="btn btn-blue px-3 mx-2 fit-content" onClick={()=>navigate(router.new_rate+'/overlapped_rate'+'/'+domain)}>
                        Add Overlapped rate
                    </Button>
                    <Button type="submit" className="btn btn-blue px-3 fit-content" disabled={props.rates.length == 0}>
                        Submit
                    </Button>
                </Box>
            </form>
        </Paper>
    );
}
